const baseUrl: string = process.env.REACT_APP_API_URL || '';

class Province {
    private uri: string;

    constructor(uri: string) {
        this.uri = uri;
    }

    public read = (params: any) => ({
        baseUrl,
        method: 'get',
        params,
        uri: this.uri,
    });
}

export default new Province('/profiles/v1/provinces');



// WEBPACK FOOTER //
// ./src/libraries/api/province.tsx